/**
 * The account's "show particle readings as the legacy counts" setting, applied.
 *
 * The SEN66 measures cumulative "smaller than X µm" number concentrations in
 * #/cm³. The legacy PTQS1005 presentation was the opposite convention —
 * "larger than X µm" per 100 cm³ — and the firmware used to do that subtraction
 * on-device, which is what made the numbers move only in steps of ten. The
 * derived view survives as a compatibility affordance, computed on the client
 * in services/particleBins.
 *
 * So this is a display choice only. The wire, what is stored, what is exported
 * and what rules match all keep the measured concentrations.
 */

/**
 * Whether this user asked for the derived legacy counts.
 *
 * The flag is nested: the API's UserResponse carries `settings`, and the flag
 * lives at `settings.playback.displayParticlesAsLegacyCounts`. Reading it off
 * the top level of `user` yields undefined, which reads as "measured" and never
 * throws — a silent way to ignore the setting, and exactly how the temperature
 * setting was lost on two pages for as long as it existed.
 */
export const prefersLegacyCounts = (user) =>
  Boolean(user?.settings?.playback?.displayParticlesAsLegacyCounts);

/** The view key the readings grid and chart switch on. */
export const particleViewFor = (user) => (prefersLegacyCounts(user) ? 'counts' : 'conc');
